// Dati autolavaggi — solo informazioni VERIFICATE da fonti pubbliche.
// I campi opzionali (services, features, reviews) verranno popolati quando l'utente fornirà i dati reali.

export const carwashes = {
  villesse: {
    slug: "villesse",
    name: "Autolavaggio Villesse",
    brand: "Ultralux Service S.r.l.",
    tagline: "Self-service 24/7 nel cuore del Friuli",
    address: "Via Massimiliano Fremaut 2, 34070 Villesse (GO)",
    shortAddress: "Villesse (GO)",
    phones: [
      { number: "+39 345 054 8060", type: "Mobile" },
    ],
    hours: "Aperto 24 ore su 24, tutti i giorni",
    hoursShort: "24/7",
    // Rating verificato da Infobel (aggregatore recensioni Google)
    rating: 4.6,
    reviewsCount: 146,
    description:
      "Autolavaggio self service attivo 24 ore su 24 a Villesse. Due impianti di autolavaggio automatico con programmi per la pulizia sottoscocca, con possibilità di pagamento con POS, contanti, banconote e con la nostra carta fedeltà, 4 piste self service per lavaggio a mano e 6 postazioni di aspirapolveri comprese di aria compressa. In più la possibilità su prenotazione dal lunedì al venerdì di lavare le macchine con operatore dentro e fuori contattando la sede al 345 054 8060.",
    // Hardware verificato
    verifiedFacts: [
      "Due autolavaggi automatici",
      "Pagamento con banconote, monete, POS e carta fedeltà",
      "Aperto 24 ore su 24, tutti i giorni",
      "Lavaggio dedicato anche per moto e camper",
    ],
    // Servizi e listino: da fornire dall'utente
    services: [],
    features: [],
    mapsEmbed:
      "https://www.google.com/maps?q=Via+Massimiliano+Fremaut+2,+34070+Villesse+GO&output=embed",
    mapsLink:
      "https://maps.google.com/?q=Via+Massimiliano+Fremaut+2,+34070+Villesse,+Italia",
    heroImage:
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/1k4gshoe_WhatsApp%20Image%202026-05-29%20at%2019.33.51.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/5nm0j6uz_Screenshot%202026-06-23%20201136.png",
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/ltcxs9hp_Screenshot%202026-06-23%20201129.png",
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/pj0jv7uz_Screenshot%202026-06-23%20201121.png",
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/1o6f5b7n_Screenshot%202026-06-23%20201154.png",
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/ikqzuit4_Screenshot%202026-06-23%20201206.png",
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/aex8d0z7_Screenshot%202026-06-23%20201213.png",
    ],
    accent: "from-cyan-400 via-cyan-300 to-blue-500",
  },
  tavagnacco: {
    slug: "tavagnacco",
    name: "Autolavaggio Tavagnacco",
    brand: "D.B.M. S.r.l.",
    tagline: "Self-service 24/7 a un passo da Udine",
    address: "Via Guglielmo Marconi 88, 33010 Tavagnacco (UD)",
    shortAddress: "Tavagnacco (UD)",
    phones: [{ number: "+39 345 054 8060", type: "Mobile" }],
    hours: "Aperto 24 ore su 24, tutti i giorni",
    hoursShort: "24/7",
    // Rating verificato da Google Maps (CID 13720123278689959662)
    rating: 4.5,
    reviewsCount: null,
    description:
      "Autolavaggio self service aperto 24 ore su 24 a Tavagnacco. Autolavaggio dotato di un lavaggio di ultimissima generazione con multioptional tra i quali il sottoscocca. 4 piste per lavaggio self service, 7 postazioni di aspirapolveri con aria compressa e profumatori.",
    verifiedFacts: [
      "Self-service 24/7",
      "Adatto a auto, moto, furgoni e camper",
      "Pagamento con banconote, monete, POS e carta fedeltà",
    ],
    services: [],
    features: [],
    mapsEmbed:
      "https://www.google.com/maps?q=Via+Guglielmo+Marconi+88,+Tavagnacco&output=embed",
    mapsLink:
      "https://maps.google.com/?q=Via+Guglielmo+Marconi+88,+33010+Tavagnacco,+Italia",
    heroImage:
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/49ct58sc_WhatsApp%20Image%202026-06-24%20at%2008.02.15%20%282%29.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/49ct58sc_WhatsApp%20Image%202026-06-24%20at%2008.02.15%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/1e7clotx_WhatsApp%20Image%202026-06-24%20at%2008.02.16.jpeg",
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/5o6dbw8z_WhatsApp%20Image%202026-06-24%20at%2008.02.15%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_carwash-villesse/artifacts/65x3tm4y_WhatsApp%20Image%202026-06-24%20at%2008.02.15.jpeg",
    ],
    accent: "from-blue-400 via-cyan-300 to-teal-400",
  },
};

// Recensioni reali da Google Maps (fornite dall'utente, copiate dal profilo Google).
export const reviewsByLocation = {
  villesse: [
    {
      name: "Serena Martini",
      rating: 5,
      text: "Ottimo servizio di pulizia auto e sanificazione sedili. Ragazzi super efficienti e disponibili a venire incontro ad ogni esigenza. Positiva — Puntualità, Qualità, Professionalità, Valore.",
    },
    {
      name: "Piery Folla",
      rating: 4,
      text: "Buone le postazioni di lavaggio e aspirazione, spaziose e numerose. Prezzi molto buoni.",
    },
    {
      name: "Stefano",
      rating: 5,
      text: "Ottima esperienza. Con 5 gettoni l'auto torna nuova. Evito di andare di sabato perché è sempre affollato! Personale gentile e professionale. Forse migliorabile l'aspirazione.",
    },
  ],
  tavagnacco: [
    {
      name: "Jan Caldarelli",
      rating: 5,
      text: "Ottimo autolavaggio, struttura moderna e pulita. Ottimo tempo di lavaggio per gettone.",
    },
    {
      name: "Nicola Imbriani",
      rating: 5,
      text: "Il top del Top, d'altronde la gestione è di un ex venditore di auto di assoluto livello. Porto ogni settimana a lavare l'auto da loro e uso il programma senza spazzola. Auto immacolata.",
    },
    {
      name: "Luisa Bindoni",
      rating: 5,
      text: "Tutte le attrezzature sono mantenute egregiamente e molto efficaci: le lance per autolavaggio sono potenti e gli aspirapolvere per interno auto pure.",
    },
  ],
};
